import { ALPHA3_PORTABLE, INSTALLER_STATUS } from "../download";

function formatBytes(n: number): string {
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function DownloadPage() {
  return (
    <>
      <p className="mono-label">Download · Windows x64</p>
      <h1 className="display">
        Get the
        <br />
        <span className="dim">recorder.</span>
      </h1>
      <p className="lede">
        Direct download of the published Alpha.3 <strong>portable ZIP</strong>. Bytes are not proxied
        through this website. SHA-256 is listed so you can verify the file after download.
      </p>

      <div className="cta-row">
        <a className="btn" href={ALPHA3_PORTABLE.url} download={ALPHA3_PORTABLE.filename}>
          Download {ALPHA3_PORTABLE.filename}
        </a>
        <span className="btn" aria-disabled="true" title={INSTALLER_STATUS.reason}>
          Setup EXE unavailable
        </span>
      </div>

      <div className="note warn">{INSTALLER_STATUS.reason} Do not treat the ZIP as an installer.</div>

      <div className="facts">
        <div className="fact">
          <span className="mono-label">Version</span>
          <strong>{ALPHA3_PORTABLE.version}</strong>
        </div>
        <div className="fact">
          <span className="mono-label">Build</span>
          <strong>{ALPHA3_PORTABLE.buildId}</strong>
        </div>
        <div className="fact">
          <span className="mono-label">Type</span>
          <strong>{ALPHA3_PORTABLE.label}</strong>
        </div>
        <div className="fact">
          <span className="mono-label">Size</span>
          <strong>{formatBytes(ALPHA3_PORTABLE.sizeBytes)}</strong>
        </div>
      </div>

      <div className="fact" style={{ marginTop: "0.75rem" }}>
        <span className="mono-label">SHA-256</span>
        <strong className="hash">{ALPHA3_PORTABLE.sha256}</strong>
      </div>

      <div className="note">
        Download is a direct HTTPS link to the verified R2 object (same SHA-256). Preferred future
        host after DNS approval: <code>{ALPHA3_PORTABLE.preferredUrl}</code>. Updater channel and
        manifest are unchanged.
      </div>

      <ol className="prose" style={{ marginTop: "2.5rem", paddingLeft: "1.2rem" }}>
        <li>Download the portable ZIP.</li>
        <li>Extract and run the application.</li>
        <li>Install the Fabric bridge for a supported Minecraft version via the app.</li>
        <li>Fight — then review history locally.</li>
      </ol>
    </>
  );
}
